import React, { useState } from "react";
import "../styles/HeadToHeadCreate.css";

function calculateH2HMaintenanceFee(amount) {
  if (amount <= 200) return 10;
  if (amount <= 500) return 15;
  if (amount <= 700) return 20;
  if (amount <= 1500) return 25;
  if (amount <= 5000) return 30;
  return 50;
}

function HeadToHeadCreate({ onClose }) {
  const userId = localStorage.getItem("userId");
  const [amount, setAmount] = useState("");
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const [matchCode, setMatchCode] = useState(null);

  const handleCreateMatch = async () => {
    if (!amount || amount < 100) {
      alert("Minimum amount is 100");
      return;
    }
    if (!phone) {
      alert("Enter your phone number");
      return;
    }

    try {
      setLoading(true);
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/h2h/create`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ amount, phone, userId }),
      });

      const data = await res.json();

      if (data.success) {
        setMatchCode(data.matchCode);
      } else {
        alert(data.message);
      }
    } catch (err) {
      console.error(err);
      alert("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const numericAmount = Number(amount);
  const maintenanceFee = numericAmount >= 100 ? calculateH2HMaintenanceFee(numericAmount) : 0;
  const totalCharge = numericAmount + maintenanceFee;

  return (
    <div className="h2h-create-overlay">
      <div className="h2h-create-modal">
        <button className="close-btn" onClick={onClose}>×</button>

        {!matchCode ? (
          <>
            <h3>Create Head-to-Head Match</h3>
            <input
              type="tel"
              placeholder="Enter phone number"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
            <input
              type="number"
              placeholder="Enter amount (KES)"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
            />
            {numericAmount >= 100 && (
              <p className="h2h-maintenance-fee-note">
                You will be charged KES {totalCharge} (KES {numericAmount} stake + KES {maintenanceFee} maintenance fee)
              </p>
            )}
            <button onClick={handleCreateMatch} disabled={loading} className="create-button-create">
              {loading ? "Processing..." : "Create Match"}
            </button>
          </>
        ) : (
          <div className="match-code-box">
            <h3>Match Created</h3>
            <p>Share this code with your opponent:</p>
            <div className="code">{matchCode}</div>
            <button onClick={() => navigator.clipboard.writeText(matchCode)}>
              Copy Code
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default HeadToHeadCreate;